import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

/**
 * NeoPills
 * Controle segmentado outonal de alta fidelidade (Pill Switcher).
 * Ideal para alternar presets de períodos (Hoje, Semana, Mês), filtros rápidos,
 * ou visualizações sem poluir a interface.
 * Adota cantos arredondados hiper-suaves, transições tácteis e tipografia Outfit.
 */
const NeoPills = ({
    options = [], // Array de { id, label, icon }
    activeId,
    onChange,
    className = '',
    style = {},
    ...props
}) => {
    return (
        <div 
            className={`neo-pills-container ${className}`} 
            style={style} 
            {...props}
        >
            {options.map((opt) => {
                const isActive = activeId === opt.id;
                return (
                    <button
                        key={opt.id}
                        type="button"
                        className={classnames('neo-pill-btn', { active: isActive })}
                        onClick={() => onChange(opt.id)}
                    >
                        {opt.icon && <i className={`mdi ${opt.icon} me-1.5`}></i>}
                        <span>{opt.label}</span>
                    </button>
                );
            })}
        </div>
    );
};

NeoPills.propTypes = {
    options: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
            label: PropTypes.string.isRequired,
            icon: PropTypes.string
        })
    ).isRequired,
    activeId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    onChange: PropTypes.func.isRequired,
    className: PropTypes.string,
    style: PropTypes.object
};

export default NeoPills;
